// Trektopia design tokens — taken from the Hotel Master reference screens (design-references/
// hotel-master-list.png and add-new-hotel.png). One place for the colours, radii, shadows and sizes
// those screens use, so every hotel component reads the same values instead of repeating hex codes.

export const tk = {
  color: {
    primary: '#1D5BEF',
    primaryHover: '#1649C9',
    primarySoft: '#EAF1FF',
    primaryBorder: '#C9DAFB',

    pageBg: '#F5F7FB',
    surface: '#FFFFFF',
    surfaceMuted: '#F8FAFD',
    border: '#E3E8F0',
    borderStrong: '#D3DAE6',
    divider: '#EDF1F6',

    text: '#0F1B2D',
    heading: '#0B1F3A',
    textSecondary: '#5B6B82',
    textMuted: '#8592A6',
    link: '#1D4ED8',

    star: '#F5A524',
    success: '#1F9D55',
    successSoft: '#E3F6EA',
    successText: '#1B7F3B',
    warning: '#E8912D',
    warningSoft: '#FEF1DC',
    warningText: '#9A6100',
    danger: '#E5484D',
    dangerSoft: '#FDE8E8',
    dangerText: '#C23434',
    neutralSoft: '#ECEFF4',
    neutralText: '#3E4A5C',
    pink: '#FDF0F3',
    pinkText: '#D6336C',
    aiSoft: '#EEF3FF',
    aiGreenSoft: '#EAF7EE',
  },

  // The dark navigation rail.
  shell: {
    bg: '#FFFFFF',
    bgRaised: '#F7F8FA',
    active: '#E7EEF7',
    activeSub: '#EEF3F9',
    activeText: '#1D4E89',
    hover: '#F3F5F8',
    text: '#374151',
    textMuted: '#6B7280',
    border: '#E5E7EB',
    width: 208,
  },

  radius: { sm: 6, md: 8, lg: 10, xl: 12, pill: 999 },
  shadow: {
    card: '0 1px 2px rgba(16, 24, 40, 0.04)',
    raised: '0 2px 8px rgba(16, 24, 40, 0.06)',
    button: '0 1px 2px rgba(29, 91, 239, 0.25)',
  },

  size: {
    topbar: 64,
    input: 38,
    button: 40,
    buttonLg: 44,
    tableRow: 60,
    thumbW: 76,
    thumbH: 46,
    kpiIcon: 46,
    stepDot: 30,
  },

  font: {
    pageTitle: 24,
    sectionTitle: 17,
    cardTitle: 15,
    body: 13,
    small: 12,
    tiny: 11,
    kpiValue: 22,
  },
} as const;

/** Status pill colours for every hotel lifecycle state. */
export function statusTone(status?: string | null): { bg: string; fg: string; label: string } {
  switch (status) {
    case 'Active': return { bg: tk.color.successSoft, fg: tk.color.successText, label: 'Active' };
    case 'Inactive': return { bg: tk.color.neutralSoft, fg: tk.color.neutralText, label: 'Inactive' };
    case 'Draft': return { bg: tk.color.warningSoft, fg: tk.color.warningText, label: 'Draft' };
    case 'Pending': return { bg: tk.color.warningSoft, fg: tk.color.warningText, label: 'Pending' };
    case 'TemporarilyClosed': return { bg: tk.color.primarySoft, fg: '#2B63C9', label: 'Temporarily Closed' };
    case 'Blacklisted': return { bg: tk.color.dangerSoft, fg: tk.color.dangerText, label: 'Blacklisted' };
    case 'Archived': return { bg: tk.color.neutralSoft, fg: tk.color.textMuted, label: 'Archived' };
    default: return { bg: tk.color.neutralSoft, fg: tk.color.neutralText, label: status ?? '—' };
  }
}
